import { render, staticRenderFns } from "./newChampionships.vue?vue&type=template&id=48f89e57"
import script from "./newChampionships.vue?vue&type=script&lang=js"
export * from "./newChampionships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports